"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7420],{

/***/ 86029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ styled$1; },
/* harmony export */   "z": function() { return /* binding */ styled; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21483);


const styled = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"];
var styled$1 = styled;




/***/ }),

/***/ 37420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LeftRightStickyBannerBlock": function() { return /* binding */ LeftRightStickyBannerBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86029);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin-top: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  position: absolute;\n  right: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  left: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n  margin-right: auto;\n  width: 1264px;\n  z-index: -1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  object-fit: fill;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.4s;\n  &:hover {\n    transform: scale(1.05);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



const StickyBannerImg = (param)=>{
    let { width , height , url , image  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Banner, {
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledImg, {
                src: image
            })
        })
    });
};
const LeftRightStickyBannerBlock = (param)=>{
    let { leftBlock , rightBlock , stickyTop =72  } = param;
    const leftBanners = leftBlock === null || leftBlock === void 0 ? void 0 : leftBlock.cookedData;
    const rightBanners = rightBlock === null || rightBlock === void 0 ? void 0 : rightBlock.cookedData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyWrapper, {
        stickyTop: stickyTop,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerListLeft, {
                    children: leftBanners === null || leftBanners === void 0 ? void 0 : leftBanners.map((banner)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyBannerImg, {
                                width: (ref = banner.imageSize) === null || ref === void 0 ? void 0 : ref.width,
                                height: (ref1 = banner.imageSize) === null || ref1 === void 0 ? void 0 : ref1.height,
                                url: banner.url,
                                image: banner.image
                            })
                        }, banner.id);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Middle, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerListRight, {
                    children: rightBanners === null || rightBanners === void 0 ? void 0 : rightBanners.map((banner)=>{
                        var ref, ref1;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: banner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyBannerImg, {
                                width: (ref = banner.imageSize) === null || ref === void 0 ? void 0 : ref.width,
                                height: (ref1 = banner.imageSize) === null || ref1 === void 0 ? void 0 : ref1.height,
                                url: banner.url,
                                image: banner.image
                            })
                        }, banner.id);
                    })
                })
            ]
        })
    });
};
const StickyWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((param)=>{
    let { stickyTop  } = param;
    return "\n    position: sticky;\n    top: ".concat(stickyTop, "px;\n    display: flex;\n    justify-content: center;\n");
});
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(_templateObject());
const Banner = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((param)=>{
    let { width , height  } = param;
    return "\n    margin-bottom: 16px;\n    width: ".concat(width || 150, "px;\n    height: ").concat(height || 350, "px;\n");
});
const BannerListLeft = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(_templateObject1());
const BannerListRight = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(_templateObject2());
const Middle = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(_templateObject3());
const StyledImg = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.img */ .z.img(_templateObject4());


/***/ })

}]);